import { FunctionComponent } from "react"
import { useRouter } from "next/navigation"
import numberSplitter from "./numberSplitter"
import {
  Colors,
  ProductMin,
  ProductState
} from "@/services/m-commerce-api/product/product"
import { useLanguage } from "@/context/LanguageContext"
import { resolveImageUrl } from "@/utils/constants"
import { useTheme } from "@/context/ThemeContext"
interface Props {
  product: ProductMin
  brand: string
}

const ProductCard: FunctionComponent<Props> = ({ product, brand }) => {
  const router = useRouter()
  const { theme } = useTheme()
  const { locale } = useLanguage()
  const handlePush = (): void => {
    // documentId нь CMS-ийн republish бvрд ӨӨРЧЛӨГДДӨГГvй тогтвортой утга
    // (mcommerce-ийн numeric id-ийн адилаар өөрчлөгддөггvй), тул энэ линк
    // цаг хугацаанд тогтвортой хэвээр vлдэнэ.
    router.push("/product/" + product.documentId)
  }

  const productStates = product.productState || []
  return (
    <div
      key={product.id}
      className="group/item flex flex-col cursor-pointer rounded-2xl bg-textInverse lg:hover:shadow-2xl lg:hover:-translate-y-1 transition-all duration-300 p-2"
      onClick={handlePush}
    >
      <div className="rounded-xl p-3">
        {productStates.length === 0 ? (
          <div className="h-8" />
        ) : productStates.length <= 2 ? (
          <div className="flex flex-col gap-1.5">
            {productStates.map((state, index) => (
              <div
                key={index}
                style={{
                  borderColor:
                    theme === "dark"
                      ? state.borderHexcodeDark
                      : state.borderHexcode,
                  backgroundColor:
                    theme === "dark" ? state.bgHexcodeDark : state.bgHexcode
                }}
                className="rounded-lg px-2 font-bold flex justify-center items-center w-fit h-8 gap-1.5 border border-1"
              >
                <div
                  className="w-4 h-4"
                  style={{
                    maskImage: `url(${resolveImageUrl(state.icon)})`,
                    WebkitMaskImage: `url(${resolveImageUrl(state.icon)})`,
                    maskSize: "contain",
                    maskPosition: "center",
                    backgroundColor:
                      theme === "dark"
                        ? state.iconHexcodeDark
                        : state.iconHexcode
                  }}
                />
                <p
                  style={{
                    color:
                      theme === "dark"
                        ? state.textHexcodeDark
                        : state.textHexcode
                  }}
                  className="text-sm leading-4"
                >
                  {locale === "en" ? state.nameEn : state.nameMn}
                </p>
              </div>
            ))}
          </div>
        ) : (
          <div className="flex gap-1.5">
            {productStates.map((state, index) => (
              <div
                key={index}
                style={{
                  borderColor:
                    theme === "dark"
                      ? state.borderHexcodeDark
                      : state.borderHexcode,
                  backgroundColor:
                    theme === "dark" ? state.bgHexcodeDark : state.bgHexcode
                }}
                className="rounded-lg px-2 font-bold flex justify-center items-center w-fit h-8 gap-1 border"
              >
                <div
                  className="w-4 h-4"
                  style={{
                    maskImage: `url(${resolveImageUrl(state.icon)})`,
                    WebkitMaskImage: `url(${resolveImageUrl(state.icon)})`,
                    maskSize: "contain",
                    maskPosition: "center",
                    backgroundColor:
                      theme === "dark"
                        ? state.iconHexcodeDark
                        : state.iconHexcode
                  }}
                />
              </div>
            ))}
          </div>
        )}

        {/* <div className={`text-textInverse rounded-lg px-3 font-semibold lg:text-sm text-xs flex justify-center items-center w-[116px] h-8 ${product.productState.id === 1 ? 'bg-gradient-to-r from-[#7C4CB0] to-[#5F86EC] ' : 'bg-[#06BC9A]'}`}>
              {
                product.productState.id === 1
                  ? <Image draggable={false} width={16} height={16} className='w-5 h-5 mr-2' src='/images/demo/gift.png' alt={product.nameEn} />
                  : <Image draggable={false} src={repeatIcon} alt='?' width={16} height={16} className='mr-1' />
              }
              <p>{product.productState.nameMn}</p>
            </div> */}
        <div className="w-full flex justify-center">
          <img
            draggable={false}
            width={1000}
            height={1000}
            className="aspect-square w-[255px]  object-contain"
            src={
              product.coverImage !== undefined
                ? resolveImageUrl(product.coverImage)
                : "/images/noImage.jpeg"
            }
            alt={product.nameEn}
          />
        </div>
        <ul className="flex">
          {product.colors.map((color: Colors, i: number) => (
            <li
              key={product.id.toString() + i.toString()}
              className="w-6 aspect-square"
            >
              <div
                className="rounded-full w-4 h-4 border border-slate-300"
                style={{ backgroundColor: color.hexCode }}
              />
            </li>
          ))}
        </ul>
      </div>

      {/* <Image draggable={false} width={140} height={140} className='object-contain h-[180px] lg:h-[208px] w-full' style={{ width: '100%', height: 'auto' }} src={'https://osa.mobicom.mn' + (product.coverImage ?? '/images/noImage.jpeg')} alt={product.name_en} /> */}
      <div className="flex flex-col py-4 px-2 border-t border-dashed border-secondaryMidStroke">
        <span className="text-xs text-textMid font-bold">{brand}</span>
        <span className="text-main h-10 text-textHigh text-sm font-bold">
          {product.nameEn}
        </span>
        <div className="flex flex-col md:flex-row items-start md:items-center">
          <span className="text-lg font-bold text-textHigh">
            {numberSplitter(product.price)}₮
          </span>
          {product.listPrice !== 0 ? (
            <span className="text-textMid font-normal line-through text-sm md:ml-2">
              {numberSplitter(product.listPrice)}₮
            </span>
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  )
}
export default ProductCard
